export const THEMES = {
  dark: 'dark',
  light: 'light',
};
